import Vue from 'vue'
import * as uiv from 'uiv'
import 'bootstrap/dist/css/bootstrap.min.css'
Vue.use(uiv)




// WEBPACK FOOTER //
// ./src/plugins/bootstrap.js